// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * OPC UA security policy applied to the secure channel.
 */
export enum SecurityPolicy {
  None_ = 0,
  Basic128Rsa15 = 1,
  Basic256 = 2,
  Basic256Sha256 = 3,
  Aes128Sha256RsaOaep = 4,
  Aes256Sha256RsaPss = 5,
}
